import PropTypes from 'prop-types';
import SchoolYearType from './schoolYearType';
import OrderType from './orderType';
import BillingItemAmountType from './billingItemAmountType';

const BalanceTransactionType = PropTypes.shape({
  id: PropTypes.string,
  transaction_id: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  created: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  type: PropTypes.string,
  currency: PropTypes.string,
  fee: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  base_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  convenience_fee: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  transaction_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  platform_fee: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  merchant_fee: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  net: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  source: PropTypes.string,
  student_name: PropTypes.string,
  school_year: SchoolYearType,
  order: OrderType,
  billing_item_amounts: PropTypes.arrayOf(BillingItemAmountType)
});

export default BalanceTransactionType;
